import React from "react";
import styled from "@emotion/styled";
import SearchResults from "../../../../pages/Dashboard/components/PropertySearch/components/SearchResults";

const PropertyDetails = ({ handleCloseModal, mortgageData }) => {

  return (
    <PropertyDetailsPanel>
      <PanelHeader>
        <HeaderText>
          Property Details
        </HeaderText>
        <HeaderMeta>
          Public-record property dossier
        </HeaderMeta>
      </PanelHeader>
      <PanelBody>
        <SearchResults propertyDetails={mortgageData.recordDetails} mortgageData={mortgageData} origin={'propertyDetails'} />
      </PanelBody>
    </PropertyDetailsPanel>
  )
}

const PropertyDetailsPanel = styled.section(({ theme }) => `
  width: 100%;
  height: 100%;
  max-height: 100%;
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  background: ${theme.palette.common.cardBackground};
  overflow: hidden;
`)

const PanelHeader = styled.header(({ theme }) => `
  min-height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.7rem;
  padding: 0.8rem 1rem;
  border-bottom: 0.1rem solid ${theme.palette.common.grayBorder};
  background: ${theme.palette.common.white};
  color: ${theme.palette.common.grayText};
`)

const HeaderText = styled.span(({ theme }) => `
  color: ${theme.palette.common.black};
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
`)

const HeaderMeta = styled.span(({ theme }) => `
  color: ${theme.palette.common.grayText};
  font-size: 0.9rem;
  font-weight: 600;
`)

const PanelBody = styled.div(({ theme }) => `
  min-height: 0;
  display: flex;
  justify-content: center;
  padding: 1rem;
  overflow: hidden;
  background: ${theme.palette.common.grayBorderLight};
`)

export default PropertyDetails;
